import api from "../../Utils/interface";

export const downloadReports = async (
  paymentDateFrom,
  paymentDateTo,
  agName,
  entityType,
) => {

  // no ag_name -> no AG filter on the server, i.e. every AG in one report
  const bodyMap = {
    ODR: {
      ...(agName && { ag_name: agName }),
      ...(paymentDateTo && paymentDateFrom && {
            payment_date__from: paymentDateFrom,
            payment_date__to: paymentDateTo,
      })
    },
    AGM: {
      ...(agName && { ag_name: agName }),
    },
  };

  const reqBody = bodyMap[entityType] || null;

  try {
    const response = await api.post(
      `/entity/download-report?entityType=${entityType}`,
      reqBody,
      {
        headers: {
          "Content-Type": "application/json",
          Accept:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "blob",
      }
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const a = document.createElement("a");
    a.href = url;
    a.download = "Report.xlsx";
    document.body.appendChild(a);
    a.click();
    a.remove();
  } catch (error) {
    console.error("Error while downloading:", error);
  }
};


